//地域別に表示される文章の設定
const Message = {
    categoryName: {
        'ja': 'konashi5',
        'ja-Hira': 'こなし5',
        'en': 'konashi5',
    },
    connect: {
        'ja': '接続する',
        'ja-Hira': 'つなぐ',
        'en': 'connect',
    },
    done: {
        'ja': '接続が完了したとき',
        'ja-Hira': 'つなぎ おわったら',
        'en': 'When connected',
    },
    setIO:{
        'ja': "PIO [pin] を [in_out] にする",
        'ja-Hira': 'PIO [pin] を [in_out] にする',
        'en': 'Set PIO [pin] to [in_out].',
    },
    input:{
        'ja': '入力',
        'ja-Hira': 'にゅうりょく',
        'en': 'read value',
    },
    output:{
        'ja': '出力',
        'ja-Hira': 'しゅつりょく',
        'en': 'write value',
    },
    openD:{
        'ja': 'オープンドレイン',
        'ja-Hira': 'おーぷんどれいん',
        'en': 'open drain',
    },
    openS:{
        'ja': 'オープンソース',
        'ja-Hira': 'おーぷんそーす',
        'en': 'open source',
    },
    setPull:{
        'ja': '[pin]ピンを[pull]にする',
        'ja-Hira': '[pin]ピンを[pull]にする',
        'en': 'Set PIO [pin] to [pull].',
    },
    pullN:{
        'ja': 'プルなし',
        'ja-Hira': 'ぷるなし',
        'en': 'no pull',
    },
    pullU:{
        'ja': 'プルアップ',
        'ja-Hira': 'ぷるあっぷ',
        'en': 'pull up',
    },
    pullD:{
        'ja': 'プルダウン',
        'ja-Hira': 'ぷるだうん',
        'en': 'pull down',
    },
    writeGpio: {
        'ja': '[pin]ピン を [high_low] にする',
        'ja-Hira': '[pin]ぴん を [high_low] にする',
        'en': 'Set PIO [pin] to [high_low].',
    },
    toggle: {
        'ja': 'トグル',
        'ja-Hira': 'とぐる',
        'en': 'TOGGLE',
    },
    readGpio: {
        'ja': 'PIO [pin] の [io]値 を読む',
        'ja-Hira': 'PIO [pin] の [io]ち をよむ',
        'en': 'Read PIO [pin]\'s [io] value.',
    },
    setSoftPWM: {
        'ja': 'softPWM PIN[pin]の[ctrlt]を[value]にする',
        'ja-Hira': 'softPWM PIN [pin] の[ctrlt]を[value]にする',
        'en': 'softPWM Set PIN [pin] with a fixed [ctrlt] of [value](%,ms).',
    },
    outSoftPWM: {
        'ja': 'softPWM PIN[pin]を[trans]msかけて[value]にする',
        'ja-Hira': 'softPWM PIN [pin]を[trans]msかけて[value]にする',
        'en': 'softPWM Set PIN [pin] to [value] in [trans] ms.'
    },
    duty: {
        'ja': 'デューティー [0.1%]',
        'ja-Hira': 'でゅーてぃー [0.1%]',
        'en': 'duty [0.1%]',
        'ja': 'デューティー [0.1%]',
        'ja-Hira': 'でゅーてぃー [0.1%]',
        'en': 'duty [0.1%]',
    },
    period: {
        'ja': '周期 [ms]',
        'ja-Hira': 'しゅうき [ms]',
        'en': 'period [ms]',
    },
    readSoftPWM: {
        'ja': 'softPWM PIN[pin]の[readtype]を読む',
        'ja-Hira': 'softPWM PIN[pin]の[readtype]をよむ',
        'en': 'Read softPWM PIN [pin]\'s [readtype] value.'
    },
    setHardPwmPin: {
        'ja': 'hardPWM PIN [pin]を有効にする',
        'ja-Hira': 'hardPWM PIN [pin]をゆうこうにする',
        'en': 'enable hardPWM PIN [pin].',
    },
    setHardPWM: {
        'ja': 'hardPWM タイマークロックを[clk]Hz, 分周比[presc], TOPカウンタを[value] にする',
        'ja-Hira': 'hardPWM たいまーくろっくを[clk]Hz, ぶんしゅうひ[presc], とっぷかうんたを[value] にする',
        'en': 'Set hardPWM with a fixed period of [clk]Hz, devide by [presc], MAX [value].',
    },
    outHardPWM: {
        'ja': 'hardPWM PIN[pin]を[trans]msかけて[value]にする',
        'ja-Hira': 'hardPWM PIN [pin]を[trans]msかけて[value]にする',
        'en': 'Use hardPWM PIN [pin] to [value] in [trans] ms transitions.'
    },
    readHardPWM: {
        'ja': 'hardPWM PIN[pin]の[readtype]を読む',
        'ja-Hira': 'hardPWM PIN[pin]の[readtype]をよむ',
        'en': 'Read hardPWM PIN[pin]\'s [readtype] value.'
    },
    value: {
        'ja': '出力値',
        'ja-Hira': 'しゅつりょくしている あたい',
        'en': 'out value',
    },
    trans:{
        'ja': '遷移時間[ms]',
        'ja-Hira': 'せんいじかん[ms]',
        'en': 'trans [ms]',
    },
    updateAna: {
        'ja': 'ADC を ([upt]+1)x100 ms 周期で更新する(~255)',
        'ja-Hira': 'ADC を [upt]ms しゅうき で こうしん する(~255)',
        'en': 'Set ADC update period to [upt]ms.(~255)'
    },
    setAio0: {
        'ja': 'AIO0 を [in_out] にする',
        'ja-Hira': 'AIO0 を [in_out] にする',
        'en': 'Use AIO0 as [in_out]'
    },
    setAio: {
        'ja': 'AIO[pin] を [in_out] にする',
        'ja-Hira': 'AIO[pin] を [in_out] にする',
        'en': 'Use AIO[pin] as [in_out]'
    },
    adcPeriod: {
        'ja': ' ADCを[peri]msごとに更新する(~255)',
        'ja-Hira': 'ADCを[peri]msごとにこうしんする(~255)',
        'en': 'Set ADC update period to [peri] ms.(~255)'
    },
    adcVref: {
        'ja': 'ADC の電圧参照値を[ref]にする',
        'ja-Hira': 'ADC のでんあつさんしょうちを[ref] にする',
        'en': 'Set ADC voltage reference to [ref].'
    },
    vdacVref: {
        'ja': 'VDAC の電圧参照値を[ref]にする',
        'ja-Hira': 'VDAC の でんあつさんしょうちを[ref]にする',
        'en': 'Set VDAC voltage reference to [ref].'
    },
    idacCran: {
        'ja': 'IDAC の電流範囲を[range]にする',
        'ja-Hira': 'IDAC のでんりゅうはんいを[range]にする',
        'en': 'Set IDAC current range to [range].'
    },
    disable: {
        'ja': '無効',
        'ja-Hira': 'むこう',
        'en': 'disable'
    },
    lowNoise: {
        'ja': '低ノイズ',
        'ja-Hira': 'ていのいず',
        'en': 'low noise'
    },
    step: {
        'ja': 'ずつ',
        'ja-Hira': 'ずつ',
        'en': 'step'
    },
    outAio0: {
        'ja': ' AIO0のIDACを[trans]ms で[ctrl]uA にする',
        'ja-Hira': 'AIO0のIDACを[trans]ms で[ctrl]uA にする',
        'en': 'Set AIO0 current to [ctrl]ms in [trans]ms.'
    },
    outAio: {
        'ja': ' AIO[pin]を[trans]msで[ctrl]V にする',
        'ja-Hira': ' AIO[pin]を[trans]msで[ctrl]V にする',
        'en': 'Set AIO[pin] voltage to [ctrl]V in [trans]ms.'
    },
    readAio: {
        'ja': 'AIO[pin] の [in_out] を読む',
        'ja-Hira': 'AIO[pin] の [in_out] をよむ',
        'en': 'Read AIO[pin] [in_out]'
    },
    setI2c:{
        'ja': 'I2Cを[i2cmode]モードにする',
        'ja-Hira': 'I2Cを[i2cmode]もーど にする',
        'en': 'Use I2C in [i2cmode] mode.',
    },
    /*writeI2c:{
        'ja': 'I2Cを[io], 読込み長さ[rlen], アドレス:[addr] で使う',
        'ja-Hira': 'I2Cを[i2cmode], [rlen], [addr] で つかう',
        'en': 'Write [data] to address [addr].',
    },*/
    writeI2c:{
        'ja': '[addr] に [value] を書き込む',
        'ja-Hira': '[addr] に [value] を かく',
        'en': 'Write [value] to address [addr].',
    },
    readI2c:{
        'ja': '[addr] から [rlen]バイト読む',
        'ja-Hira': '[addr] から [rlen]ばいと よむ',
        'en': 'Read [rlen] bytes from address [addr].',
    },
    bothI2c:{
        'ja': '[addr] に [value] を書き込んで [rlen]バイト読む',
        'ja-Hira': '[addr] に [value] をかいて [rlen]ばいと よむ',
        'en': 'Write [value] and read [rlen] bytes from address [addr].',
    },
    resultI2c:{
        'ja': 'I2C で 受けた値',
        'ja-Hira': 'I2C で うけた あたい',
        'en': 'the value recieved in I2C.',
    },
    standard:{
        'ja': '100kB/s',
        'ja-Hira': '100kB/s',
        'en': '100kB/s'
    },
    fast:{
        'ja': '400kB/s',
        'ja-Hira': '400kB/s',
        'en': '400kB/s',
    },
    setUart:{
        'ja': 'UARTを[baud]のボーレート、[parity]パリティ、[stopbit]のストップビットに設定する',
        'ja-Hira': 'UARTを[baud]のぼーれーと、[parity]ぱりてぃ、[stopbit]のすとっぷびっとにする',
        'en': 'Use UART at [baud] baud with [parity] parity and [stopbit] stop bits.',
    },
    sendUart:{
        'ja': 'UART で[value]を 書き込む',
        'ja-Hira': 'UART で[value]を おくる',
        'en': 'Write [value] in UART',
    },
    readUart:{
        'ja': 'UART で 受けた値',
        'ja-Hira': 'UART で うけた あたい',
        'en': 'the value recieved in UART.',
    },
    setSpi:{
        'ja': 'SPIを[speed] bit/s の[first]ファーストで、モード[mode]に設定',
        'ja-Hira': 'SPIを[speed] bit/s の[first]ふぁーすと で、もーど[mode]にする',
        'en': 'Use SPI at [speed] bit/s with [first] first , mode [mode].',
    },
    writeSpi:{
        'ja': 'SPI で[value]を 書き込む',
        'ja-Hira': 'SPI で[value]を かく',
        'en': 'Transfer [value].',
    },
    readSpi:{
        'ja': 'SPI で 受けた値',
        'ja-Hira': 'SPI で うけた あたい',
        'en': 'the value recieved in SPI.',
    },
    writeSpi:{
        'ja': 'SPI で[value]を 書き込む',
        'ja-Hira': 'SPI で[value]を かく',
        'en': 'Transfer [value].',
    },
    readSpi:{
        'ja': 'SPI で 受けた値',
        'ja-Hira': 'SPI で うけた あたい',
        'en': 'the value recieved in SPI.',
    },
    pres: {
        'ja': '気圧センサー',
        'ja-Hira': 'きあつ',
        'en': 'the pressure sensor',
    },
    temp: {
        'ja': '気温センサー',
        'ja-Hira': 'きおん',
        'en': 'the temperature sensor',
    },
    humi: {
        'ja': '湿度センサー',
        'ja-Hira': 'しつど',
        'en': 'the humidity sensor',
    },
    detec: {
        'ja': '人感センサーの反応',
        'ja-Hira': 'ちかくにひとがいるか',
        'en': 'Get the value of the presence detector.',
    },
    ag: {
        'ja': '[xyz]軸の[AorG]の値',
        'ja-Hira': '[xyz]じくの[AorG]をあたい',
        'en': 'Get the values of the [xyz] [AorG].',
    },
    accel: {
        'ja': '加速度',
        'ja-Hira': 'かそくど',
        'en': 'accelerometer',
    },
    gylo: {
        'ja': '傾き',
        'ja-Hira': 'かたむき',
        'en': 'gyroscope',
    },
    setColor: {
        'ja': 'フルカラーLEDの[color]を[bright]の明るさに設定(~255)',
        'ja-Hira': 'ふるからーLEDの[color]を[bright]にせってい(~255)',
        'en': 'Set the value of [color] light to [bright] (~255).'
    },
    Red: {
        'ja': '赤色',
        'ja-Hira': 'あかいろ',
        'en': 'red'
    },
    Green: {
        'ja': '緑色',
        'ja-Hira': 'みどりいろ',
        'en': 'green'
    },
    Blue: {
        'ja': '青色',
        'ja-Hira': 'あおいろ',
        'en': 'blue'
    },
    Alpha: {
        'ja': '明るさ',
        'ja-Hira': 'あかるさ',
        'en': 'bright'
    },
    outColorLED: {
        'ja': 'フルカラーLEDの色を[trans]msかけてに変更',
        'ja-Hira': 'ふるからーLEDのいろを[trans]ms かけてへんこう',
        'en': 'Full-color LEDs glow in [trans] ms transitions.'
    },
    getColorLEDRed: {
        'ja': '赤色 の明るさを読む',
        'ja-Hira': 'あかいろ のあたいをよむ',
        'en': 'Read red color value.'
    },
    getColorLEDGre: {
        'ja': '緑色 の明るさを読む',
        'ja-Hira': 'みどりいろ のあたいをよむ',
        'en': 'Read green color value.'
    },
    getColorLEDBlu: {
        'ja': '青色 の明るさを読み取る',
        'ja-Hira': 'あおいろ のあたいをよむ',
        'en': 'Read blue color value.'
    },
    getColorLEDA: {
        'ja': '明るさ を読む',
        'ja-Hira': 'あかるさ をよむ',
        'en': 'Read bright value.'
    },
    getColorLEDTra: {
        'ja': '状態遷移までの残り時間 (ms)',
        'ja-Hira': 'のこりじかん (ms)',
        'en': 'Read trans (ms) value.'
    },
    changed: {
        'ja': '[data]になったとき',
        'ja-Hira': '[data] に なったら',
        'en': 'When [data]'
    },
    seqNum: {
        'ja': '数列[data]の[num]番目',
        'ja-Hira': '[data]の[num]ばんめ',
        'en': 'the [num]th in sequence [data].'
    },
    seqDelAdd: {
        'ja': '数列[data]の[num]番目から[del]個削除して[add]を入れる',
        'ja-Hira': '[data]の[num]ばんめ から[del]こ けして[add]をいれる',
        'en': 'Delete [del] items from the [num]th of the sequence [data] and insert [add].'
    },
    seqLen: {
        'ja': '数列[data]の長さ',
        'ja-Hira': '[data]の長さ',
        'en': 'the length of the sequence [data].'
    },
    byteTrans: {
        'ja': 'バイト列[data]を[type][endian]として読む',
        'ja-Hira': 'ばいとれつ[data]を[type][endian]として よむ',
        'en': 'Read byte string [data] as [type][endian].'
    },
    byteCul: {
        'ja': 'int [data][cul][data2]',
        'ja-Hira': 'int64[data][cul][data2]',
        'en': 'int [data][cul][data2].'
    },
    bitCont: {
        'ja': 'bit[data][cont][data2]',
        'ja-Hira': 'bit[data][cont][data2]',
        'en': 'bit[data][cont][data2].'
    },
    connectionState: {
        none: {
            'ja': '左のチェックボックスを押してね',
            'ja-Hira': 'ひだりのしかくをおしてね',
            'en': 'Please click the left checkbox',
        },
        not_found: {
            'ja': '見つかりません',
            'ja-Hira': 'みつかりません',
            'en': 'could not connect',
        },
        try: {
            'ja': '接続中',
            'ja-Hira': 'せつぞくちゅう',
            'en': 'connecting...',
        },
        connected: {
            'ja': '接続しました',
            'ja-Hira': 'せつぞくしました',
            'en': 'connected',
        },
        disconnecting: {
            'ja': '切断中',
            'ja-Hira': 'せつだんちゅう',
            'en': 'disconnecting...',
        },
        lost: {
            'ja': '消えました',
            'ja-Hira': 'きえました',
            'en': 'lost connection',
        }
    },
    reset: {
        'ja': 'リセット',
        'ja-Hira': 'リセット',
        'en': 'reset',
    },
    disconnect_alert: {
        'ja': '接続を失いました。再接続するにはチェックボックスを一度外して、初めから接続をしてください。',
        'ja-Hira': 'つなぐことができませんでした。もういちどつなぎたいばあい、チェックボックスをはずして、はじめからやりなおしてください。',
        'en': 'disconnected. Release the checkbox of connect block and re-connect the device.',
    },
    lost_alert: {
        'ja': '接続を失いました。再接続するにはチェックボックスを一度外して、初めから接続をしてください。',
        'ja-Hira': 'つなぐことができませんでした。もういちどつなぎたいばあい、チェックボックスをはずして、はじめからやりなおしてください。',
        'en': 'disconnected. Release the checkbox of connect block and re-connect the device.',
    }
}

exports.msg = Message;